import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { select, Store } from '@ngrx/store';
import { selectZefDialogState } from '@zerops/zef/dialog';
import { map } from 'rxjs/operators';
import { FEATURE_NAME } from './client-user-role-dialog.constant'

@Component({
  selector: 'z-client-user-role-dialog',
  templateUrl: './client-user-role-dialog.container.html',
  styleUrl: './client-user-role-dialog.container.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientUserRoleDialogContainer extends ZefReactiveComponent {
  // # Deps
  #store = inject(Store);

  // -- async
  dialogState$ = this.#store.pipe(select(selectZefDialogState(FEATURE_NAME)));
  open$ = this.dialogState$.pipe(map((data) => data.state));

  // # State resolver
  state = this.$connect({
    open: this.open$
  });

  constructor() {
    super();

    // # Dispatcher
    this.$dispatchActions([
      //
    ]);
  }

  reload() {
    window.location.reload();
  }
}
